import { forwardRef } from 'react';

import { tss } from 'tss-react/mui';
import Link from 'next/link';

import type { Or2ButtonProps } from './Or2Button';
import { Or2Button } from './Or2Button';

const useStyles = tss.create(() => {
  return {
    root: {
      borderRadius: '20px',
      cursor: 'pointer',
    },
  };
});

export type Or2LinkButtonProps = Or2ButtonProps & {
  href: string;
  isExternal?: boolean;
  scroll?: boolean;
  prefetch?: boolean;
};

export const Or2LinkButton = forwardRef<HTMLButtonElement, Or2LinkButtonProps>(
  (
    {
      variant = 'contained',
      disableElevation = true,
      children,
      className,
      href,
      isExternal,
      scroll = true,
      prefetch = true,
      ...other
    },
    ref,
  ) => {
    const { classes, cx } = useStyles();

    return (
      <Link
        href={href}
        target={isExternal ? '_blank' : undefined}
        rel={isExternal ? 'noopener noreferrer' : undefined}
        scroll={scroll}
        prefetch={prefetch}
      >
        <Or2Button
          ref={ref}
          className={cx(classes.root, className)}
          variant={variant}
          disableElevation={disableElevation}
          {...other}
        >
          {children}
        </Or2Button>
      </Link>
    );
  },
);

Or2LinkButton.displayName = 'Or2LinkButton';
